import { User } from '../types';

export enum SupervisorActionType {
    GET_ALL_SUPERVISOR = 'GET_ALL_SUPERVISOR',
    PUT_SUPERVISOR_BENCHMARK = 'PUT_SUPERVISOR_BENCHMARK',
    PUT_SUPERVISOR_CAPACITY = 'PUT_SUPERVISOR_CAPACITY',
}

interface GetAllSupervisorAction {
    type: SupervisorActionType;
    payload: Array<User>;
}

interface SupervisorCapacity {
    type: SupervisorActionType;
    payload: { supervisor: User };
}

export type SupervisorAction = GetAllSupervisorAction | SupervisorCapacity;
